import type { ElementType } from 'react';
import { abtests } from '@eti/utils';
import { useLocation } from 'react-router-dom';
import { getRouteNameByPathName } from '../../../constants/routesAndApisConstants';

export const withAbTests = (WrappedComponent: ElementType) => (props: any) => {
  const location = useLocation();
  abtests.executeAbTestCallbacks(getRouteNameByPathName(location.pathname) ?? '');
  return <WrappedComponent {...props} />;
};

export default withAbTests;
